/** UUID with non-crypto fallback (analytics ids need uniqueness, not crypto strength). */
export function newUuid(): string {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
        return crypto.randomUUID()
    }
    return `id-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`
}
